import { render, staticRenderFns } from "./bscClueOnlineMatrixList.vue?vue&type=template&id=96d7b3fa&scoped=true"
import script from "./bscClueOnlineMatrixList.vue?vue&type=script&lang=js"
export * from "./bscClueOnlineMatrixList.vue?vue&type=script&lang=js"
import style0 from "./bscClueOnlineMatrixList.vue?vue&type=style&index=0&id=96d7b3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d7b3fa",
  null
  
)

export default component.exports